import { Activity, DashboardActivityVM } from '@/core/models/activity';
import { Tile } from '@/core/models/tile';

export class ActivityDashboadVmMapper {
    static mapToVms(
        activities: Activity[],
        dateFormat: string,
        timeFormat: string,
        tiles: Tile[],
    ): DashboardActivityVM[] {
        return activities.map((activity) => this.mapToVm(activity, dateFormat, timeFormat, tiles));
    }

    static mapToVm(activity: Activity, dateFormat: string, timeFormat: string, tiles: Tile[]): DashboardActivityVM {
        const start = activity.startDate;
        const end = activity.endDate;

        const startTime = start.format(timeFormat);
        const endTime = end.format(timeFormat);

        const durationSeconds = end.diff(start, 'seconds');

        const mappedTiles = activity.tileIds.map((tile) => tiles.find((t) => t.id === tile)?.name ?? '');

        return {
            time: startTime + ' - ' + endTime,
            layer1: mappedTiles[0],
            layer2: mappedTiles[1],
            layer3: mappedTiles[2],
            note: activity.note,
            durationSeconds: durationSeconds,
            color: tiles.find((t) => t.name === mappedTiles[0])?.color ?? '#90CAF9',
        };
    }
}
